function parseRushRange(title) {
	const clean = title.replace(/\$/g, '').replace(/,/g, '').trim();

	if (clean.startsWith('<')) {
		return { min: -Infinity, max: parseFloat(clean.replace('<', '').trim()) };
	}

	if (clean.startsWith('>')) {
		return { min: parseFloat(clean.replace('>', '').trim()), max: Infinity };
	}

	const rangeMatch = clean.match(/^(\d+(?:\.\d+)?)\s*-\s*(\d+(?:\.\d+)?)$/);
	if (rangeMatch) {
		return { min: parseFloat(rangeMatch[1]), max: parseFloat(rangeMatch[2]) };
	}
	return null;
}

const currencySymbolMap = {
  AED: 'د.إ',
  AFN: '؋',
  ALL: 'L',
  AMD: '֏',
  ANG: 'ƒ',
  AOA: 'Kz',
  ARS: '$',
  AUD: '$',
  AWG: 'ƒ',
  AZN: '₼',
  BAM: 'KM',
  BBD: '$',
  BDT: '৳',
  BGN: 'лв',
  BHD: '.د.ب',
  BIF: 'FBu',
  BMD: '$',
  BND: '$',
  BOB: '$b',
  BOV: 'BOV',
  BRL: 'R$',
  BSD: '$',
  BTC: '₿',
  BTN: 'Nu.',
  BWP: 'P',
  BYN: 'Br',
  BYR: 'Br',
  BZD: 'BZ$',
  CAD: '$',
  CDF: 'FC',
  CHE: 'CHE',
  CHF: 'CHF',
  CHW: 'CHW',
  CLF: 'CLF',
  CLP: '$',
  CNH: '¥',
  CNY: '¥',
  COP: '$',
  COU: 'COU',
  CRC: '₡',
  CUC: '$',
  CUP: '₱',
  CVE: '$',
  CZK: 'Kč',
  DJF: 'Fdj',
  DKK: 'kr',
  DOP: 'RD$',
  DZD: 'دج',
  EEK: 'kr',
  EGP: '£',
  ERN: 'Nfk',
  ETB: 'Br',
  ETH: 'Ξ',
  EUR: '€',
  FJD: '$',
  FKP: '£',
  GBP: '£',
  GEL: '₾',
  GGP: '£',
  GHC: '₵',
  GHS: 'GH₵',
  GIP: '£',
  GMD: 'D',
  GNF: 'FG',
  GTQ: 'Q',
  GYD: '$',
  HKD: '$',
  HNL: 'L',
  HRK: 'kn',
  HTG: 'G',
  HUF: 'Ft',
  IDR: 'Rp',
  ILS: '₪',
  IMP: '£',
  INR: '₹',
  IQD: 'ع.د',
  IRR: '﷼',
  ISK: 'kr',
  JEP: '£',
  JMD: 'J$',
  JOD: 'JD',
  JPY: '¥',
  KES: 'KSh',
  KGS: 'лв',
  KHR: '៛',
  KMF: 'CF',
  KPW: '₩',
  KRW: '₩',
  KWD: 'KD',
  KYD: '$',
  KZT: '₸',
  LAK: '₭',
  LBP: '£',
  LKR: '₨',
  LRD: '$',
  LSL: 'M',
  LTC: 'Ł',
  LTL: 'Lt',
  LVL: 'Ls',
  LYD: 'LD',
  MAD: 'MAD',
  MDL: 'lei',
  MGA: 'Ar',
  MKD: 'ден',
  MMK: 'K',
  MNT: '₮',
  MOP: 'MOP$',
  MRO: 'UM',
  MRU: 'UM',
  MUR: '₨',
  MVR: 'Rf',
  MWK: 'MK',
  MXN: '$',
  MXV: 'MXV',
  MYR: 'RM',
  MZN: 'MT',
  NAD: '$',
  NGN: '₦',
  NIO: 'C$',
  NOK: 'kr',
  NPR: '₨',
  NZD: '$',
  OMR: '﷼',
  PAB: 'B/.',
  PEN: 'S/.',
  PGK: 'K',
  PHP: '₱',
  PKR: '₨',
  PLN: 'zł',
  PYG: 'Gs',
  QAR: '﷼',
  RMB: '￥',
  RON: 'lei',
  RSD: 'Дин.',
  RUB: '₽',
  RWF: 'R₣',
  SAR: '﷼',
  SBD: '$',
  SCR: '₨',
  SDG: 'ج.س.',
  SEK: 'kr',
  SGD: 'S$',
  SHP: '£',
  SLL: 'Le',
  SOS: 'S',
  SRD: '$',
  SSP: '£',
  STD: 'Db',
  STN: 'Db',
  SVC: '$',
  SYP: '£',
  SZL: 'E',
  THB: '฿',
  TJS: 'SM',
  TMT: 'T',
  TND: 'د.ت',
  TOP: 'T$',
  TRL: '₤',
  TRY: '₺',
  TTD: 'TT$',
  TVD: '$',
  TWD: 'NT$',
  TZS: 'TSh',
  UAH: '₴',
  UGX: 'USh',
  USD: '$',
  UYI: 'UYI',
  UYU: '$U',
  UYW: 'UYW',
  UZS: 'лв',
  VEF: 'Bs',
  VES: 'Bs.S',
  VND: '₫',
  VUV: 'VT',
  WST: 'WS$',
  XAF: 'FCFA',
  XBT: 'Ƀ',
  XCD: '$',
  XOF: 'CFA',
  XPF: '₣',
  XSU: 'Sucre',
  XUA: 'XUA',
  YER: '﷼',
  ZAR: 'R',
  ZMW: 'ZK',
  ZWD: 'Z$',
  ZWL: '$',
};


function isHidden(el) {
  const style = window.getComputedStyle(el);
  return (style.display === 'none')
}

class QuantityInput extends HTMLElement {
	constructor() {
		super();
		this.input = this.querySelector('input');
		this.changeEvent = new Event('change', { bubbles: true });
		this.minusButton = this.querySelector('button[name="minus"]');
		this.plusButton = this.querySelector('button[name="plus"]');

		this.querySelectorAll('button').forEach(
			(button) => button.addEventListener('click', this.onButtonClick.bind(this))
		);

		this.input.addEventListener('input', this.onInputChange.bind(this));

		this.input.addEventListener('keydown', (e) => {
			const allowedKeys = ['Backspace', 'ArrowLeft', 'ArrowRight', 'Delete', 'Tab'];
			if (!allowedKeys.includes(e.key) && !/^\d$/.test(e.key)) {
				e.preventDefault();
			}
		});
	}

	onButtonClick(event) {
		event.preventDefault();
		const previousValue = this.input.value;

		event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
		if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);

		this.updateButtonStates();
	}

	onInputChange() {
		clearTimeout(this.inputTimeout);

		this.inputTimeout = setTimeout(() => {
			let value = parseInt(this.input.value, 10);
			const min = parseInt(this.input.min, 10) || 1;
			const max = this.input.max ? parseInt(this.input.max, 10) : Infinity;

			if (isNaN(value)) return; 

			value = Math.max(min, Math.min(max, value));
			this.input.value = value;
			this.input.dispatchEvent(this.changeEvent);

			this.updateButtonStates();
		}, 200); 
	}

	updateButtonStates() {
		const value = parseInt(this.input.value, 10);
		const min = parseInt(this.input.min, 10) || 1;
		const max = this.input.max ? parseInt(this.input.max, 10) : Infinity;

		value <= min
			? this.minusButton.setAttribute('disabled', 'disabled')
			: this.minusButton.removeAttribute('disabled');

		value >= max
			? this.plusButton.setAttribute('disabled', 'disabled')
			: this.plusButton.removeAttribute('disabled');
	}
}

customElements.define('quantity-input', QuantityInput);

class productFlow extends HTMLElement {
	constructor() {
		super();

		this.price = this.querySelector('[data-price]')
		this.productTypes = this.querySelector('product-types')
		this.quantity = this.querySelector('quantity-input')?.input.value
		this.customizeItContainer = this.querySelector('.product__customize-it-js')
		this.popupLinks = this.querySelectorAll('.pdp-flow__step a[href*="#"]')

		this.querySelector('label[for="customization-true"]')?.addEventListener('click', () => {
			this.customizeItContainer.querySelector('.js-open-customize-it').click()
		})

		this.addEventListener('change', (e) => {
			this.currentStep = e.target.closest('.pdp-flow__step')


			if (e.target.name === 'product type' && e.target.value == 'drop it yourself tool') {
				this.updateCustomizerState(e.target.value)
			}

			if (e.target.type === 'checkbox') {
				const uncheckedInputs = e.target.closest('.pdp-flow__step').querySelector('input[type="checkbox"][required]:not(:checked)')

				if (!uncheckedInputs) {
					this.onStepChange()
				}
			} else if (e.target.id !== 'customization-true') {
				this.onStepChange()
			}

			if (e.target.name === 'id') {
				this.selectedVariant = e.target.value
				this.selectedVariantName = e.target.getAttribute('data-variant-name')
				this.updateMasterId()
			}

			this.updatePrice()
			this.productTypes.updateProcessing()
		})

		this.popupLinks.forEach(item => {
			item.addEventListener('click', (e) => {
				e.preventDefault();

				const modal = document.querySelector(e.target.getAttribute('href'));

				if (modal) modal.show(this);
			})
		})
	}

	updateCustomizerState(value) {
		this.customizerSelected = value === 'drop it yourself tool'
		//this.customizerSelected ? this.customizeItContainer?.classList.add('show') : this.customizeItContainer?.classList.remove('show')

		this.querySelectorAll('[data-customizer-toggle]').forEach((item) => {
			if (this.customizerSelected) {
				item.setAttribute('aria-hidden', 'true')
			} else {
				item.setAttribute('aria-hidden', 'false')
			}
		})
	}

	onStepChange() {
		this.nextStep = this.currentStep.nextElementSibling

		if (isHidden(this.nextStep)) {
			this.nextStep = this.currentStep.nextElementSibling.nextElementSibling
		}

		this.nextStepActive = this.nextStep.classList.contains('disabled')

		if (this.nextStep.hasAttribute('data-quantity-step')) {
			this.nextStep.nextElementSibling.classList.remove('disabled')
		}

		if (this.nextStep && this.nextStepActive) {
			const headerOffset = 75;
			const elementPosition = this.nextStep.getBoundingClientRect().top;
			const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

			window.scrollTo({
				top: offsetPosition,
				behavior: "smooth"
			});

			//this.nextStep.scrollIntoView({ behavior: 'smooth'})
			this.nextStep.classList.remove('disabled')
		}

		const hasSpecificHeader = this.nextStep.querySelector(
			'div.pdp-flow__step[data-customizer-toggle] h3.pdp-flow__label'
		);

		if (hasSpecificHeader && hasSpecificHeader.textContent.trim() === "What type of project is this for?") {
			const nextSection = this.nextStep.nextElementSibling;
			if (nextSection && nextSection.classList.contains('disabled')) {
				nextSection.classList.remove('disabled');
			}
		}

		if (this.nextStep.querySelectorAll('.pdp-flow__variants .variant-card[aria-hidden="false"]').length === 1) {
			this.nextStep.querySelector('.pdp-flow__variants .variant-card[aria-hidden="false"] label').click()
		}

		if (this.nextStep.nextElementSibling.hasAttribute('data-shipping-step') && this.productTypes.productType === 'sample') {
			// this.nextStep.nextElementSibling.querySelector('.label[for="processing-standard"]').click()
		}

		if (this.nextStep.nextElementSibling.querySelector('#processing-standard') !== null && !this.nextStep.nextElementSibling.querySelector('#processing-rush') && this.productTypes.productType === 'normal') {
			this.nextStep.nextElementSibling.nextElementSibling.classList.remove('disabled')
		}
		if (this.nextStep.nextElementSibling.querySelector('#processing-standard') !== null && this.productTypes.productType === 'sample') {
			this.nextStep.nextElementSibling.querySelector('input#processing-standard').checked = true
			this.nextStep.nextElementSibling.nextElementSibling.classList.remove('disabled')
			this.nextStep.nextElementSibling.nextElementSibling.nextElementSibling.classList.remove('disabled')

			if (this.nextStep.nextElementSibling.nextElementSibling.nextElementSibling.getAttribute('aria-hidden') === 'true') {
				this.nextStep.nextElementSibling.nextElementSibling.nextElementSibling.nextElementSibling.classList.remove('disabled')
			}

		}
	}

	updateMasterId() {
		if (!this.selectedVariant) {
			return
		}

		this.currentVariant = this.getVariantData().find(variant => variant.id == this.selectedVariant);

		const typesMix = this.productTypes.productType + '+' + this.selectedVariantName

		const qtyDescription = this.querySelector(`.js-type-sample[data-qty-description="${typesMix}"]`)

		this.querySelectorAll(`.js-type-sample`).forEach((item) => {
			if (item == qtyDescription) {
				item.setAttribute('aria-hidden', false)
			} else {
				item.setAttribute('aria-hidden', true)
			}
		})
		if (qtyDescription == null) {
			this.productTypes.switchFormSteps(true)
		}
	}

	getVariantData() {
		this.variantData =
			this.variantData ||
			JSON.parse(this.querySelector('[type="application/json"]').textContent);
		return this.variantData;
	}

	updatePrice() {
		if (!this.currentVariant) {
			return
		}

		this.quantity = this.querySelector('quantity-input').input.value

		this.total = this.currentVariant.price * this.quantity

		if (this.productTypes.rushProcessingProduct && this.querySelector('[name="processing"][value="rush"]:checked')) {
			this.total += this.productTypes.rushProcessingProduct.price
		}

		this.price.textContent = Shopify.formatMoney(
			this.total,
			`${currencySymbolMap[Shopify.currency.active]}{{amount}}`
		);

		const sampleSizeInput = this.querySelector('[name="properties[Sample size]"]:checked')
		const largeSamplePrice = parseInt(this.querySelector('[name="large_size_sample_price"]')?.value) || 0

		if (sampleSizeInput?.value === '26"' && largeSamplePrice) {
			this.total += largeSamplePrice * this.quantity
		}

		this.price.textContent = Shopify.formatMoney(
			this.total,
			`${currencySymbolMap[Shopify.currency.active]}{{amount}}`
		);


		if (this.total > 1999900) {
			this.querySelector('.message--20k').style.display = 'block'
		} else if (this.querySelector('.message--20k').style.display == 'block') {
			this.querySelector('.message--20k').style.display = 'none'
		}
	}
}

customElements.define('product-flow-form', productFlow);


class productTypes extends HTMLElement {
  constructor() {
    super();
    this.productFlow = document.querySelector('product-flow-form')
  
  
    this.addEventListener('change', (e) => {
      this.productType = e.target.value
      this.switchFormSteps()
      this.updateProcessing()
    })
  }
  
  switchFormSteps (qty_description) {
    //updateCustomizerState
    
    this.productFlow.updateCustomizerState(false)
    
    //disable new step -
    
    if (document.querySelector('product-type') != null) {
      this.parentNode.nextElementSibling.nextElementSibling.classList.add('disabled')
    }
    
    this.productFlow.querySelectorAll('.js-item-type').forEach((item) => {
      if (item.dataset.variantType === this.productType) {
        // console.log(this.productFlow.querySelector(`[name="properties[Project type]"]:checked`)?.value)
        item.setAttribute('aria-hidden', 'false')
      } else {
        item.setAttribute('aria-hidden', 'true')
      }
      
      if (!qty_description && item.querySelector('input:checked')) {
        item.querySelector('input:checked').checked = false
        item.querySelector('input').dispatchEvent(new Event("change"));
        
        this.productFlow.querySelectorAll(`.js-type-sample`).forEach((item) => {
          if (item.hasAttribute('data-qty-description')) {
            item.setAttribute('aria-hidden', true)
          }
        })
      }
    })
  }

	updateProcessing() {
		this.rushProcessingProduct = window.processing[this.productType]
		this.processingContainer = this.productFlow.querySelector('.js-processing-form')
		this.processingPrice = this.processingContainer?.querySelector('[data-processing-price]')
		this.processingID = this.processingContainer?.querySelector('[data-processing-id]')
		this.processingType = this.processingContainer?.querySelector('[data-processing-type]')

		this.checkSelectedProcessing = this.processingContainer?.querySelector('#processing-rush:checked')

		if (!this.rushProcessingProduct) {
			return
		}

		const totalDollars = this.productFlow.total / 100; 

		if (this.productType === 'normal') {
			const variants = window.processing['normal_variants'];

			const matchedVariant = variants.find(item => {
				const range = parseRushRange(item.title);
				if (!range) return false;
				return totalDollars >= range.min && totalDollars <= range.max;
			});
			this.rushProcessingProduct = matchedVariant || variants[variants.length - 1];
		}

		if (this.processingPrice) {
			this.processingPrice.textContent = Shopify.formatMoney(
				this.rushProcessingProduct?.price,
				`${currencySymbolMap[Shopify.currency.active]}{{amount}}`
			);
		}

		if (this.checkSelectedProcessing) {
			this.processingID.value = this.rushProcessingProduct.id
			this.processingType.value = this.productType == 'sample' ? this.productType : 'on'
		} else {
			if (this.processingID) {
				this.processingID.value = ''
				this.processingType.value = ''
			}
		}
	}
}
customElements.define('product-types', productTypes);

class projectType extends HTMLElement {
  constructor() {
    super();
    this.productFlow = document.querySelector('product-flow-form')
    this.productType = document.querySelector('product-types')
    
    this.addEventListener('change', (e) => {
      this.switchFormSteps(e.target.value)
    })
  }
  
  switchFormSteps (value) {
    this.productFlow.querySelectorAll('.js-item-type.variant-card').forEach((item) => {
      if (item.querySelector('input:checked') !== null) {
        item.querySelector('input:checked').checked = false
      }
      
      if (item.dataset.variantType === this.productType?.productType && item.hasAttribute('data-project-type') && value === "Both") {
        item.setAttribute('aria-hidden', 'false')
      } else if (item.dataset.variantType === this.productType?.productType && item.hasAttribute('data-project-type') && item.dataset.projectType === value) {
        item.setAttribute('aria-hidden', 'false')
      } else {
        item.setAttribute('aria-hidden', 'true')
      }
    })
  }
}
customElements.define('project-type', projectType);



class CustomizeItVariants extends HTMLElement {
  constructor() {
    super();
    
    window.addEventListener(
      'change-main-product-form',
      this.handleMainFormChange.bind(this)
    );
    
    window.addEventListener(
      'change-customize-it-quantity',
      this.updateTotalPrice.bind(this)
    );
    
    this.addEventListener('change', this.onVariantChange);
    
    this.customizeIt = document.querySelector('customize-it');
    this.customizeItSelect = this.querySelector('select');
    this.customizeItForm = document.querySelector('customize-it-form');
    this.variantInput = this.customizeItForm.querySelector('input[name="id"]');
    this.customizeItFormQuantity = this.customizeItForm.querySelector(
      'input[name="quantity"]'
    );
    this.customizeItFormPrice = this.customizeItForm.querySelector('.price');
    
    this.panelImgs = document.querySelectorAll('[data-panel-img]');
    
    this.getVariantData();
    
    this.currentVariant = this.variantData[0];
    this.updateTotalPrice();
    this.preloadImages();
  }
  
  handleMainFormChange(e) {
    const mainFormVariant = e.detail.variant;
    this.variantData = e.detail.variantData;
    
    this.currentVariant = this.variantData.find(variant => {
      const variantTitleStripPerFoot = variant.title
        .replace('(per foot)', '')
        .replace('-', '')
        .trim();
      
      return mainFormVariant.title.includes(variantTitleStripPerFoot);
    });
    
    this.updateCustomizeSelector();
  }
  
  updateCustomizeSelector() {
    if(this.customizeItSelect && this?.currentVariant?.title) {
      const currentOption = [...this.customizeItSelect.querySelectorAll("option")]
        .find(optionElement => {
          const variantTitleStripPerFoot = optionElement.value
            .replace('(per foot)', '')
            .replace('-', '')
            .trim();
          
          return this.currentVariant.title.includes(variantTitleStripPerFoot);
        });
      [...this.customizeItSelect.querySelectorAll("option")].forEach(optionElement => {
        if (optionElement === currentOption) {
          optionElement.setAttribute("selected", "true");
        } else {
          optionElement.removeAttribute("selected");
        }
      });
      try {
        this.customizeItSelect.value = currentOption.value;
      } catch(e) {
      }
      
      this.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }
  
  updateVariantInput() {
    this.variantInput.value = this.currentVariant.id;
  }
  
  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll('select:not(.js-processing-select)'),
      select => select.value
    );
  }
  
  updateMasterId() {
    this.currentVariant = this.getVariantData().find(variant => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }
  
  getVariantData() {
    if (!this.variantData) {
      this.variantData = this.querySelector('[type="application/json"]') ? JSON.parse(this.querySelector('[type="application/json"]').textContent) : []
    }
    return this.variantData;
  }
  
  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    
    if (this.currentVariant) {
      this.updateVariantInput();
      this.updateTotalPrice();
      this.updatePanelWidth();
      this.updatePanelImage();
      this.variantDetailDispatch();
    }
  }
  
  updateTotalPrice() {
    if (this?.currentVariant?.price) {
      const total = this.currentVariant.price * this.customizeItFormQuantity.value
      const customizeItForm = document.querySelector('customize-it-form');
      const ceilPrice = Math.ceil(total / 100000)*10000
      
      this.customizeItFormPrice.textContent = Shopify.formatMoney(
        total,
        window.mon.shop.moneyFormatCurrency
      );
      
      let rushProcessingProduct = window.processing["normal"]

      if (total < 249900) {
        rushProcessingProduct = window.processing["normal"]
      } else if (total > 2000100) {
        
        rushProcessingProduct = window.processing['normal_variants'][window.processing['normal_variants'].length - 1]
      } else {
        rushProcessingProduct = window.processing['normal_variants'].find(item => item.price === ceilPrice)
      }
      
      if (rushProcessingProduct) {
        customizeItForm.querySelector('.rush-processing-price').textContent = Shopify.formatMoney(
          rushProcessingProduct?.price,
          `${currencySymbolMap[Shopify.currency.active]}{{amount}}`
        );
      }
     
    }
    
  }
  
  updatePanelWidth() {
    this.customizeIt.dispatchEvent(
      new CustomEvent('panel', {
        detail: { variant: this.currentVariant },
      })
    );
  }
  
  updatePanelImage() {
    const panelImg = this.currentVariant.featured_image;

    if (!panelImg) return;
    
    this.panelImgs.forEach(
      img => (img.src = this.currentVariant.featured_image)
    );
  }
  
  preloadImages() {
    const panelImgSources = this.variantData.map(
      variant => variant.featured_image
    );
    
    panelImgSources.forEach(path => {
      if (!path) return;
      new Image().src = path;
    });
  }
  
  variantDetailDispatch() {
    this.customizeIt.dispatchEvent(
      new CustomEvent('variant', {
        detail: { variant: this.currentVariant },
      })
    );
  }
}

customElements.define('customize-it-variants', CustomizeItVariants);


class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this, false)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    
    this.addEventListener('click', (event) => {
      if (event.target === this) this.hide();
    });
  }
  
  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }
  
  show(opener) {
    this.openedBy = opener;
    bodyScrollLock.disableBodyScroll(this);
    this.setAttribute('open', '');
  }
  
  hide() {
    bodyScrollLock.clearAllBodyScrollLocks();
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
  }
}

customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();
    
    this.button = this.querySelector('button');
    
    if (!this.button) return;
    
    this.button.addEventListener('click', this.onClick.bind(this));
  }
  
  onClick(e) {
    const modal = document.querySelector(this.getAttribute('data-modal'));
    
    if (modal) modal.show(this.button);
  }
}

customElements.define('modal-opener', ModalOpener);

document.addEventListener("DOMContentLoaded", function() {
  const variantSelects = document.querySelector("variant-selects");
  
  if (variantSelects) {
    variantSelects.dispatchEvent(new Event("change"));
    
    const openCustomize = document.querySelector(".js-open-customize-it");
    if (openCustomize) {
      openCustomize.addEventListener("click", function() {
        const heightInput = document.querySelector("[name='properties[Wall Width]']");
        heightInput.dispatchEvent(new Event("input"));
      });
    }
  }
  
  const customizeItForm = document.querySelector('customize-it-form');
  
  if (customizeItForm) {
    customizeItForm.addEventListener("submit", function(event) {
      event.stopImmediatePropagation();
    }, true);
  }
});

class SwiperSlider extends HTMLElement {
  constructor() {
    super();
    this.initSlider()
    this.slider = this;
  }
  
  initSlider() {
    const sliderData = JSON.parse(this.getAttribute('data-swiper-options'))
  
    if (this.getAttribute('data-thumbnails')) {
      const thumbnails_element = document.getElementById(this.getAttribute('data-target')) ||  document.querySelector('.product-thumbnails')
      const thumbnails_options = JSON.parse(this.getAttribute('data-thumbnails'))
      const thumbnailsSwiper = new Swiper(thumbnails_element, thumbnails_options)
    
      sliderData.thumbs = {
        swiper: thumbnailsSwiper,
        autoScrollOffset: 1
      }
    }
    
    if (!this.classList.contains('swiper-initialized')) {
      window.productGallery = new Swiper(this, sliderData)
    }
  }
}

customElements.define('swiper-slider', SwiperSlider);